import React from 'react';
import '../../styles/GridBoxes.css';
import finance from '../../assets/finance.png';
import { Link } from 'react-router-dom';

export default function SecondaryBox2 (props) {

  return (
    <div className='box'>
        <h1>{props.SecondaryBoxTitle2}</h1>

        <Link to="/finance">
        <img src={finance} 
        style={{ boxShadow: 'none' }} 
        alt="" />
        </Link>

    </div>
  );
};